import { reverseShape } from 'Helpers/reverse-shape';
import * as Yup from 'yup';
import { validName, validString } from 'Components/shared/helpers/validations';
import { identificationNumber, identificationType, passportExpiryDate, passportIssueDate, passportPlaceOfIssue } from '../../shared/helpers/validations';
import { ProfileFormInput } from 'Types/employee';

import { ShallowClonedTypeFor } from 'Types/common.types';
import {
  addressLine,
  city,
  country, fullContact, postcode,
  state
} from 'Utils/validations';

const preProfileFormSchema: Partial<ShallowClonedTypeFor<ProfileFormInput, any>> = {
  fullName: validName.required(),
  identificationType: identificationType.required(),
  identificationNumber: identificationNumber.required(),

  identificationIssueDate: passportIssueDate,
  identificationExpiryDate: passportExpiryDate,
  identificationPlaceOfIssue: passportPlaceOfIssue,
  contactNumber: Yup.lazy((value) => {
    if (!value) return Yup.string().nullable().required()
    return Yup.object().required().concat(fullContact)
  }),
  email: validString.required(),
  dob: validString.required(),
  gender: validString.optional(),

  addressLine1: Yup.string().required().concat(addressLine),
  addressLine2: Yup.lazy(value => !value ? Yup.string() : addressLine),
  state: Yup.string().required().concat(state),
  city: Yup.string().required().concat(city),
  postcode: Yup.string().required().concat(postcode),
  country: Yup.string().required().concat(country),
}

export const profileFormSchema = Yup.object().shape(reverseShape(preProfileFormSchema))